import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { WorkstationKind } from '@novapet/shared';

interface WorkstationState {
  workstation_id: string | null;
  workstation_kind: WorkstationKind | null;
  display_name: string | null;
  setWorkstation: (params: {
    workstation_id: string;
    workstation_kind: WorkstationKind;
    display_name: string;
  }) => void;
  clearWorkstation: () => void;
}

/**
 * Workstation identity is sticky per browser (rule §29). Persisted to localStorage so a
 * machine "is" a cashier station / consult-room station / admin station across reloads.
 * Operators reassign via the first-run setup screen (Stage 1).
 */
export const useWorkstationStore = create<WorkstationState>()(
  persist(
    (set) => ({
      workstation_id: null,
      workstation_kind: null,
      display_name: null,
      setWorkstation: ({ workstation_id, workstation_kind, display_name }) =>
        set({ workstation_id, workstation_kind, display_name }),
      clearWorkstation: () =>
        set({ workstation_id: null, workstation_kind: null, display_name: null }),
    }),
    { name: 'novapet:workstation' },
  ),
);
